export const styles = {
  menuItem: {
    color: "text.primary",
    padding: "8px 15px !important",
  },
};
